export default __webpack_public_path__ + "static/media/success_icon_revert.3d8be38e.svg";